import { env } from '@/lib/env';

const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z0-9+.-]*:)?\/\//i;
const LOCAL_AUDIO_PATH_PATTERN = /^\/audio\/([^?#]+)$/i;

const LEGACY_AMBIENT_FILE_ALIASES: Record<string, string> = {
  'ocean-waves.mp3': 'ocean.mp3',
};

function normalizeHostLikeUrl(value: string | undefined): string {
  const trimmed = value?.trim();
  if (!trimmed) return '';

  const withoutTrailingSlash = trimmed.replace(/\/+$/, '');
  if (/^https?:\/\//i.test(withoutTrailingSlash)) {
    return withoutTrailingSlash;
  }

  return `https://${withoutTrailingSlash}`;
}

function getBunnyAudioBaseUrl(): string {
  return normalizeHostLikeUrl(env.bunnyAudioBaseUrl);
}

function getSupabaseSoundEffectsBaseUrl(): string {
  const supabaseUrl = normalizeHostLikeUrl(env.supabaseUrl);
  if (!supabaseUrl) {
    return '';
  }

  return `${supabaseUrl}/storage/v1/object/public/sound-effects/ambient`;
}

function normalizeAmbientFileName(fileName: string): string {
  return LEGACY_AMBIENT_FILE_ALIASES[fileName] ?? fileName;
}

function encodeFileName(fileName: string): string {
  return encodeURIComponent(fileName);
}

export function buildAmbientAudioUrl(fileName: string): string {
  const normalizedFileName = normalizeAmbientFileName(fileName);
  const bunnyBaseUrl = getBunnyAudioBaseUrl();

  if (bunnyBaseUrl) {
    return `${bunnyBaseUrl}/ambient/${encodeFileName(normalizedFileName)}`;
  }

  const supabaseBaseUrl = getSupabaseSoundEffectsBaseUrl();
  if (supabaseBaseUrl) {
    return `${supabaseBaseUrl}/${encodeFileName(normalizedFileName)}`;
  }

  return `/audio/${normalizedFileName}`;
}

export function normalizeManagedAudioUrl(fileUrl: string): string {
  if (!fileUrl) {
    return fileUrl;
  }

  if (ABSOLUTE_URL_PATTERN.test(fileUrl) || fileUrl.startsWith('blob:') || fileUrl.startsWith('data:')) {
    return fileUrl;
  }

  const localAudioMatch = fileUrl.match(LOCAL_AUDIO_PATH_PATTERN);
  if (!localAudioMatch) {
    return fileUrl;
  }

  const bunnyBaseUrl = getBunnyAudioBaseUrl();
  if (!bunnyBaseUrl) {
    return fileUrl;
  }

  return buildAmbientAudioUrl(decodeURIComponent(localAudioMatch[1]));
}
